module.exports = __webpack_public_path__ + "img/MaikeAndresen_140x140_rund.b4f91af1.jpg";